enum PERMISSION_KEYS {
    approve = 'Approve',
    cptAnalytics = 'CPT Analytics',
    manageProtocols = 'Manage Protocols',
    managePolicies = 'Manage Policies',
    manageGroups = 'Manage Groups',
    manageNotes = 'Manage Notes',
    manageFiles = 'Manage Files',
    approvePolicy = 'Approve Policy',
}

export default PERMISSION_KEYS;
